module.exports = __webpack_public_path__ + "img/filter-intensity-middle.a20f6bd1.svg";